/**
 * Builds `pageDataHandler`
 * but leaves side‑effects (setters) to the caller.
 *
 * @param  data – raw GraphQL payload
 * @returns { adAcc, pubAcc, campaign, publisherNameById }
 */
export const adAccountDataTransformer = (data) => {
    if (!data) return { adAcc: {}, pubAcc: {}, campaign: null, publisherNameById: {} }

    const publishers = data.getPublishersFromPostgres ?? []
    const publisherNameById = Object.fromEntries(publishers.map((p) => [p.id, p.name]))

    const adAcc = {}
    data.getUserAdAccounts?.forEach(({ name, ad_accounts }) => {
        adAcc[name] = ad_accounts.map((acc) => ({
            id: acc.id,
            name: acc.name,
            account: acc.account,
            business_id: acc.businessId,
            tos_accepted: acc.tos_accepted,
            amount_spent: acc.amount_spent,
            month_spend: acc.month_spend,
            timezone: acc.time_zone_name,
            timezone_offset: acc.time_zone_offset,
            currency: acc.currency,
            pixels: (acc.pixels ?? []).map(({ id, name }) => ({ id, name })),
            instagram_accounts: acc.instagram_accounts,
            // Keep global_brand_page_name: brands on Facebook Global Pages share one `name`
            // ("JLL"), and only this field distinguishes "JLL (AU)" from "JLL (Default)".
            // Keep usable/unusable_reason: assets a business can see but this user cannot
            // advertise with are shown disabled rather than silently offered.
            pages: (acc.pages ?? []).map(
                ({ id, name, global_brand_page_name, instagram_account, usable, unusable_reason }) => ({
                    id,
                    name,
                    global_brand_page_name,
                    instagram_account,
                    usable,
                    unusable_reason,
                }),
            ),
            usable: acc.usable,
            unusable_reason: acc.unusable_reason,
        }))
    })

    const pubAcc = {}
    data.publisherUserAdAccounts?.forEach((item) => {
        const publisherName = publisherNameById[item.publisher_id]
        if (publisherName) pubAcc[publisherName] = item
    })

    const campaign = data.campaigns?.[0] ?? null

    return { adAcc, pubAcc, campaign, publisherNameById }
}
